import * as React from "react";

interface ConsultationContextProps {
  showBanner: boolean;
  meetingLink: string | null;
  meetingTime: string | null;
  handleScheduleCall: () => void;
  handleCloseBanner: () => void;
}

export const ConsultationContext = React.createContext<
  ConsultationContextProps | undefined
>(undefined);
